import { VisuallyHidden } from '@dcs/ui/primitives';
import { t } from '../messages/vi';
import './loading.css';

export interface LoadingProps {
  /** Inside the app frame (a header-high strip is reserved above): false on `/drive*`, `/exam*`. */
  readonly framed?: boolean;
}

/**
 * Skeleton shown while a lazy screen's chunk loads (the router's hydrate fallback). It takes the
 * height of a real screen (header strip, title, lead, three cards, the tab bar's room under 768px),
 * so the screen replaces it without moving anything. Static under reduced motion.
 */
export function Loading({ framed = true }: LoadingProps) {
  return (
    <div className="loading" data-framed={framed} aria-busy="true">
      {framed ? <div className="loading__header" aria-hidden="true" /> : null}
      <main className="loading__main">
        <p role="status">
          <VisuallyHidden>{t('common.loading')}</VisuallyHidden>
        </p>
        <div className="loading__page" aria-hidden="true">
          <div className="loading__bar loading__bar--title" />
          <div className="loading__bar loading__bar--lead" />
          <div className="loading__cards">
            <div className="loading__bar loading__card" />
            <div className="loading__bar loading__card" />
            <div className="loading__bar loading__card" />
          </div>
        </div>
      </main>
    </div>
  );
}
